/* unplugin-vue-components disabled */import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/arrow.png';
import _imports_1 from '@/assets/img/arrow_2.png';
var _hoisted_1 = {
  class: "collapse-list"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_3 = {
  class: "van-collapse-item-title"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}, null, -1);
var _hoisted_5 = {
  class: "collapse-item-title-text"
};
var _hoisted_6 = {
  class: "van-collapse"
};
var _hoisted_7 = {
  class: "van-collapse-content"
};
var _hoisted_8 = {
  class: "content-item"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备名称", -1);
var _hoisted_10 = {
  class: "content-item-value"
};
var _hoisted_11 = {
  class: "content-item"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务类型", -1);
var _hoisted_13 = {
  class: "content-item-value"
};
var _hoisted_14 = {
  class: "content-item"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "创建时间", -1);
var _hoisted_16 = {
  class: "content-item-value"
};
var _hoisted_17 = {
  class: "content-item"
};
var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "审核人", -1);
var _hoisted_19 = {
  class: "content-item-value"
};
var _hoisted_20 = {
  class: "van-collapse-footer"
};
import './collapseList.less';
// eslint-disable-next-line no-undef
export default /*#__PURE__*/_defineComponent({
  __name: 'CollapseList',
  props: {
    listData: {
      default: function _default() {
        return [];
      }
    },
    detailUrl: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var listData = props.listData;
    var activeNames = ref('');
    return function (_ctx, _cache) {
      var _component_van_collapse_item = _resolveComponent("van-collapse-item");
      var _component_van_collapse = _resolveComponent("van-collapse");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_collapse, {
        modelValue: _unref(activeNames),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(activeNames) ? activeNames.value = $event : null;
        }),
        accordion: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), function (item, index) {
            return _openBlock(), _createBlock(_component_van_collapse_item, {
              key: index,
              name: index
            }, {
              "right-icon": _withCtx(function () {
                return [_hoisted_2];
              }),
              title: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(item.taskName || '--'), 1)])];
              }),
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.deviceNameList.length ? item.deviceNameList.join(',') : '--'), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(item.inspectionTaskDesc || '-'), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(item.createTime || '--'), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString(item.assessorUserName || '--'), 1)])]), _createElementVNode("div", _hoisted_20, [_renderSlot(_ctx.$slots, "footer", {
                  item: item,
                  index: index
                })])])];
              }),
              _: 2
            }, 1032, ["name"]);
          }), 128))];
        }),
        _: 3
      }, 8, ["modelValue"])]);
    };
  }
});